import script from "./IconSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./IconSvg.vue?vue&type=script&setup=true&lang=js"

import "./IconSvg.vue?vue&type=style&index=0&id=f70125d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f70125d0"]])

export default __exports__